import { Autocomplete, Box, FormControl, Grid, Typography } from "@mui/material";
import { CustomStyledTextField } from "./ColoredTextfield";
import { Controller } from "react-hook-form";

export default function LabeledTextField({label,width,multiline,disabled,onKeyDown,disableUnderline,min,onBlur,maxRows,alignItems,height,onChange,control,rules,fontSize,labelStyle,name,endAdornment,variant , textfieldStyles, startAdornment,callback,madatory=false,onlyNumberDot=false,inputProps,...rest}) {
    return (
    <FormControl sx={{  width:width || "100%",height:"100%",gap:0 }}>
      <Controller
       control={control}
       name={name}
       rules={rules}    
        render={({field,fieldState}) =>  <Grid style={{justifyContent:"space-between"}} container rowSpacing={label?"4px":0}>
        <Grid item xs={12}>
            <Typography style={{ textAlign: "start", fontFamily: "Figtree", ...labelStyle }}>{madatory ? (
              <>
                {label}
                <span style={{ color: "red", marginLeft: 4 }}>*</span>
              </>
            ) : (
              label
            )}</Typography>
        </Grid>
        <Grid item xs={12}>
        <CustomStyledTextField
       
      disabled={disabled}
        multiline={multiline||false}
        maxRows={maxRows}
        onKeyDown={(e) =>{ 
          if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
            e.preventDefault();
          }
          if (onlyNumberDot) {
            const allowedControlKeys = [
              "Backspace", "Delete", "Tab", "Escape", "Enter",
              "ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown",
              "Home", "End"
            ];
            if (allowedControlKeys.includes(e.key)) {
              if (onKeyDown) onKeyDown(e);
              return;
            }
            if (e.ctrlKey || e.metaKey) {
              if (onKeyDown) onKeyDown(e);
              return;
            }
            if (/^[0-9]$/.test(e.key)) {
              if (onKeyDown) onKeyDown(e);
              return;
            }
            if (e.key === ".") {
              const val = e.target.value || "";
              const sel = val.substring(e.target.selectionStart, e.target.selectionEnd);
              if (!val.includes(".") || sel.includes(".")) {
                if (onKeyDown) onKeyDown(e);
                return;
              }
            }
            e.preventDefault();
            e.stopPropagation();
            return;
          }
          if(onKeyDown){
            onKeyDown(e)
          }
         }
         }
        onKeyUp={(e)=>{
          if(callback){
            console.log(e.target.value)
            callback(e.target.value);
          }
       }}
        
       

        InputProps={{
          disableUnderline,
          startAdornment:startAdornment,
          endAdornment : endAdornment,
          style :{
            backgroundColor: "white",
            fontSize : fontSize || "16px",
            height:height,
            alignItems: alignItems,
            ...textfieldStyles,
          }
        }}
        inputProps={{
          ...(inputProps || {}),
          onKeyDown: (e) => {
            if (onlyNumberDot) {
              const allowedControlKeys = [
                "Backspace", "Delete", "Tab", "Escape", "Enter",
                "ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown",
                "Home", "End"
              ];
              if (allowedControlKeys.includes(e.key)) {
                if (inputProps?.onKeyDown) inputProps.onKeyDown(e);
                return;
              }
              if (e.ctrlKey || e.metaKey) {
                if (inputProps?.onKeyDown) inputProps.onKeyDown(e);
                return;
              }
              if (/^[0-9]$/.test(e.key)) {
                if (inputProps?.onKeyDown) inputProps.onKeyDown(e);
                return;
              }
              if (e.key === ".") {
                const val = e.target.value || "";
                const sel = val.substring(e.target.selectionStart, e.target.selectionEnd);
                if (!val.includes(".") || sel.includes(".")) {
                  if (inputProps?.onKeyDown) inputProps.onKeyDown(e);
                  return;
                }
              }
              e.preventDefault();
              e.stopPropagation();
              return;
            }
            if (inputProps?.onKeyDown) {
              inputProps.onKeyDown(e);
            }
          },
          onPaste: (e) => {
            if (onlyNumberDot) {
              e.preventDefault();
              const paste = (e.clipboardData || window.clipboardData)?.getData("text") || "";
              let cleaned = paste.replace(/[^0-9.]/g, "");
              const input = e.target;
              const val = input.value || "";
              const selStart = input.selectionStart ?? 0;
              const selEnd = input.selectionEnd ?? 0;
              let combined = val.slice(0, selStart) + cleaned + val.slice(selEnd);
              combined = combined.replace(/[^0-9.]/g, "");
              const firstDot = combined.indexOf(".");
              if (firstDot !== -1) {
                combined = combined.slice(0, firstDot + 1) + combined.slice(firstDot + 1).replace(/\./g, "");
              }
              input.value = combined;
              field.onChange(combined);
              if (onChange) onChange(combined);
              if (callback) callback(combined);
              return;
            }
            if (inputProps?.onPaste) {
              inputProps.onPaste(e);
            }
          }
        }}
        sx={{padding:0,margin:0, 
          '& .MuiOutlinedInput-root': {
      padding: "0px !important", 
      paddingRight:"0px !important"
    },
          "& .MuiFormControl-root .MuiTextField-root": {
            display: 'flex',
            alignItems: 'center',
            justifyContent :"center",
            padding:"0px !important"
          },
          "& .MuiInputAdornment-positionEnd": {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          },
          "& .MuiOutlinedInput-root": {
          "&.Mui-focused": {
            fieldset: {
              borderColor: `${process.env.REACT_APP_ENTERPRISE_COLOUR} !important`, // Default focused color
            },
          },
          "&.Mui-error": {
            "&.Mui-focused": {
              fieldset: {
                borderColor: 'red !important', // Color for focused and error state
              },
            },
          },
          "&.Mui-invalid": {
            fieldset: {
              border: 'red !important', // Default focused color
            },
          },
        },
        }} error={!!fieldState.error} helperText={fieldState.error?.message} {...field} variant={variant||"outlined"} {...rest}
        onBlur={(e)=>{
          field.onBlur(e);
          if(onBlur){
            onBlur(e.target.value)
          }
        }}
        onChange={(e)=>{
          if (onlyNumberDot && e?.target?.value !== undefined && typeof e.target.value === "string") {
            let val = e.target.value.replace(/[^0-9.]/g, "");
            const firstDot = val.indexOf(".");
            if (firstDot !== -1) {
              val = val.slice(0, firstDot + 1) + val.slice(firstDot + 1).replace(/\./g, "");
            }
            e.target.value = val;
          }
          if(onChange){
            onChange(e.target.value);
          }
          field.onChange(e);
          if(callback){
            callback(e.target.value);
          }
         
        }}
        size="small" margin="normal" fullWidth/>
        </Grid>
       </Grid>
        
    //     <Box sx={{display:"flex",alignItems:"start",flexDirection:"column",width:"100%"}}>
    //         <>{label}</>
    //         <CustomStyledTextField error={!!fieldState.error} helperText={fieldState.error?.message} {...field} variant="outlined" {...rest} size="small" margin="normal" fullWidth/>
    //  </Box>
     }
      />
        </FormControl>
     
    );
  }

  export function LabeledTextField1({label,width,multiline,disabled,onKeyDown,disableUnderline,min,onBlur,maxRows,alignItems,height,onChange,control,rules,fontSize,labelStyle,name,endAdornment,variant , textfieldStyles, callback,...rest}) {
    return (
    <FormControl sx={{  width:width || "100%",height:"100%",gap:0 }}>
      <Controller
       control={control}
       name={name}
       rules={rules}    
        render={({field,fieldState}) =>  <Grid container rowSpacing={label?"4px":0}>
        <Grid item xs={12}>
        <Typography style={{textAlign:"start",fontFamily:"Figtree",...labelStyle}}>{label}</Typography>
        </Grid>
        <Grid item xs={12}>
        <CustomStyledTextField
       
      disabled={disabled}
        multiline={multiline||false}
        maxRows={maxRows}
        onKeyDown={(e) =>{ 
          if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
            e.preventDefault();
          }
          if(onKeyDown){
            onKeyDown(e)
          }
         }
         }
        onKeyUp={(e)=>{
          if(callback){
            console.log(e.target.value)
            callback(e.target.value);
          }
       }}
        
       

        InputProps={{
          disableUnderline,
          endAdornment : endAdornment,
          style :{
            backgroundColor:"white",
            fontSize : fontSize || "16px",
            height:height,
            alignItems: alignItems,
            ...textfieldStyles,
          }
        }} sx={{padding:0,margin:0, 
          '& .MuiOutlinedInput-root': {
      padding: "0px !important", 
      paddingRight:"0px !important"
    },
          "& .MuiFormControl-root .MuiTextField-root": {
            display: 'flex',
            alignItems: 'center',
            justifyContent :"center",
            padding:"0px !important"
          },
          "& .MuiInputAdornment-positionEnd": {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          },
          "& .MuiOutlinedInput-root": {
          "&.Mui-focused": {
            fieldset: {
              borderColor: `${process.env.REACT_APP_ENTERPRISE_COLOUR} !important`, // Default focused color
            },
          },
          "&.Mui-error": {
            "&.Mui-focused": {
              fieldset: {
                borderColor: 'red !important', // Color for focused and error state
              },
            },
          },
          "&.Mui-invalid": {
            fieldset: {
              border: 'red !important', // Default focused color
            },
          },
        },
        }} error={!!fieldState.error} helperText={fieldState.error?.message} {...field} variant={variant||"outlined"} {...rest}
        onBlur={(e)=>{
          e.target.value = e.target.value.trim()
          field.onBlur(e);
          if(onBlur){
            onBlur(e.target.value)
          }
        }}
        onChange={(e)=>{
          e.target.value = e.target.value.trim()
          console.log()
          if(onChange){
            onChange(e.target.value);
          }
          field.onChange(e);
          if(callback){
            callback(e.target.value);
          }
         
        }}
        size="small" margin="normal" fullWidth/>
        </Grid>
       </Grid>
        
    //     <Box sx={{display:"flex",alignItems:"start",flexDirection:"column",width:"100%"}}>
    //         <>{label}</>
    //         <CustomStyledTextField error={!!fieldState.error} helperText={fieldState.error?.message} {...field} variant="outlined" {...rest} size="small" margin="normal" fullWidth/>
    //  </Box>
     }
      />
        </FormControl>
     
    );
  }